import {
	VolunteersGalleryContextType,
	VolunteersGalleryFormData,
	VolunteersGalleryListItem,
	VolunteersGalleryRules,
} from "../context/VolunteersGalleryContext/constants";

// The add form's checks, in the order the form shows its fields; the first problem is returned. Files are checked
// one by one when they are picked (utils/galleryMedia).
export class VolunteersGalleryValidator {
	static validateAddVolunteersGallery(data: VolunteersGalleryFormData, galleries: VolunteersGalleryListItem[]): string | null {
		if (data.contextType === null) {
			return "Lütfen galerinin gösterileceği yeri seçin.";
		}

		if (data.contextType === VolunteersGalleryContextType.Event && !data.contextId) {
			return "Lütfen galerinin gösterileceği projeyi seçin.";
		}

		const contextId = data.contextType === VolunteersGalleryContextType.Event ? data.contextId : null;
		if (galleries.some(gallery => gallery.contextType === data.contextType && gallery.contextId === contextId)) {
			return data.contextType === VolunteersGalleryContextType.MainPage
				? "Ana sayfa galerisi zaten var. Yeni görselleri o galeriye ekleyebilirsiniz."
				: "Seçilen projenin galerisi zaten var. Yeni görselleri o galeriye ekleyebilirsiniz.";
		}

		if (data.files.length > VolunteersGalleryRules.maxFileCount) {
			return `Bir seferde en fazla ${VolunteersGalleryRules.maxFileCount} dosya yüklenebilir.`;
		}

		return null;
	}
}
